// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Structure Move Dialog Styles
 *
 * Uses CFN theme variables for light/dark theme support.
 * See /app/public/css/cfn-theme.css for variable definitions.
 */

/*
 * CRITICAL FIX: Allow map interaction through the dialog overlay
 * The dialog overlay blocks all pointer events to the map beneath.
 * We disable pointer events on the overlay so users can drag markers,
 * but re-enable them on the dialog content itself.
 */
[data-radix-dialog-overlay] {
  pointer-events: none !important;
}

.structure-move-dialog {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  pointer-events: auto;
  color: var(--cfn-text-primary);
  background: var(--cfn-bg-secondary);
}

/* Ensure alerts have good contrast */
.structure-move-dialog [role="alert"] {
  color: var(--cfn-text-primary);
}

.structure-move-content {
  padding: 1rem 0;
}

/* Mode selector */
.mode-selector {
  margin-bottom: 1rem;
}

.mode-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 0.5rem;
  border: 1px solid var(--cfn-border);
  border-radius: 0.375rem;
  background: var(--cfn-bg-tertiary);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--cfn-text-secondary);
}

.mode-btn:hover {
  background: var(--cfn-bg-elevated);
  border-color: var(--cfn-accent-primary);
  color: var(--cfn-accent-primary);
}

.mode-btn.active {
  background: var(--cfn-accent-primary-muted);
  border-color: var(--cfn-accent-primary);
  color: var(--cfn-accent-primary);
  font-weight: 600;
}

.mode-btn i,
.mode-btn svg {
  margin-bottom: 0.25rem;
}

/* Distance indicator */
.distance-indicator {
  padding: 1rem;
  border-radius: 0.5rem;
  background: var(--cfn-bg-tertiary);
  border: 1px solid var(--cfn-border);
  transition: all 0.3s ease;
}

.distance-indicator.status-safe {
  background: var(--cfn-success-muted);
  border-color: var(--cfn-success);
}

.distance-indicator.status-warning {
  background: var(--cfn-warning-muted);
  border-color: var(--cfn-warning);
}

.distance-indicator.status-danger {
  background: var(--cfn-danger-muted);
  border-color: var(--cfn-danger);
}

.distance-indicator.status-exceeded {
  background: var(--cfn-danger-muted);
  border-color: var(--cfn-danger);
}

.distance-bar {
  width: 100%;
  height: 8px;
  background: var(--cfn-bg-elevated);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.distance-fill {
  height: 100%;
  transition: all 0.3s ease;
  border-radius: 4px;
}

.status-safe .distance-fill {
  background: linear-gradient(90deg, var(--cfn-success), var(--cfn-success-text));
}

.status-warning .distance-fill {
  background: linear-gradient(90deg, var(--cfn-warning), var(--cfn-warning-text));
}

.status-danger .distance-fill {
  background: linear-gradient(90deg, var(--cfn-danger), var(--cfn-danger-text));
}

.status-exceeded .distance-fill {
  background: linear-gradient(90deg, var(--cfn-danger), #991b1b);
}

.distance-text {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.distance-value {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--cfn-text-primary);
}

.status-safe .distance-value {
  color: var(--cfn-success-text);
}

.status-warning .distance-value {
  color: var(--cfn-warning-text);
}

.status-danger .distance-value {
  color: var(--cfn-danger-text);
}

.status-exceeded .distance-value {
  color: var(--cfn-danger-text);
}

.distance-max {
  font-size: 0.875rem;
  color: var(--cfn-text-muted);
}

/* Position summary */
.position-summary {
  padding: 0.75rem;
  background: var(--cfn-bg-tertiary);
  border-radius: 0.375rem;
  border: 1px solid var(--cfn-border);
}

/* Input fields */
.mode-inputs input[type="number"] {
  font-family: ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;
  color: var(--cfn-input-text);
  background: var(--cfn-input-bg);
  border: 1px solid var(--cfn-input-border);
  border-radius: 0.375rem;
}

.mode-inputs input[type="number"]:focus {
  border-color: var(--cfn-input-focus-border);
  box-shadow: 0 0 0 3px var(--cfn-input-focus-ring);
  outline: none;
}

.mode-inputs input[type="number"]:disabled {
  color: var(--cfn-text-disabled);
  background: var(--cfn-bg-tertiary);
}

/* Ensure all input placeholders are visible but not too dark */
.mode-inputs input::-moz-placeholder {
  color: var(--cfn-input-placeholder);
}
.mode-inputs input::placeholder {
  color: var(--cfn-input-placeholder);
}

/* Leaflet marker styles */
.structure-move-ghost-marker {
  opacity: 0.4;
  z-index: 9000 !important;
}

.ghost-marker-inner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--cfn-text-muted);
  border: 2px solid var(--cfn-bg-primary);
  box-shadow: var(--cfn-shadow-md);
}

.structure-move-preview-marker {
  opacity: 1;
  cursor: move;
  z-index: 10000 !important;
}

.preview-marker-inner {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--cfn-accent-primary);
  border: 3px solid var(--cfn-bg-primary);
  box-shadow: 0 4px 12px var(--cfn-focus-ring);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--cfn-btn-primary-text);
  font-size: 14px;
  transition: all 0.2s ease;
}

.structure-move-preview-marker:hover .preview-marker-inner {
  transform: scale(1.1);
  box-shadow: 0 6px 16px var(--cfn-focus-border);
}

.structure-move-preview-marker.leaflet-drag-target .preview-marker-inner {
  transform: scale(1.2);
  box-shadow: 0 8px 20px var(--cfn-accent-primary);
  background: var(--cfn-accent-primary-hover);
}

/* Floating drag panel - shown instead of full dialog in drag mode */
.structure-move-drag-panel {
  position: fixed;
  top: 1rem;
  right: 1rem;
  width: 320px;
  background: var(--cfn-bg-secondary);
  border: 1px solid var(--cfn-border);
  border-radius: 0.5rem;
  box-shadow: var(--cfn-shadow-xl);
  z-index: 10000;
  pointer-events: auto;
}

.drag-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid var(--cfn-border);
}

.drag-panel-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  color: var(--cfn-text-primary);
}

.drag-panel-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--cfn-text-muted);
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s;
}

.drag-panel-close:hover {
  background: var(--cfn-bg-tertiary);
  color: var(--cfn-text-primary);
}

.drag-panel-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--cfn-danger-muted);
  border-left: 3px solid var(--cfn-danger);
  color: var(--cfn-danger-text);
  font-size: 0.875rem;
}

.drag-panel-success {
  padding: 0.75rem 1rem;
  background: var(--cfn-success-muted);
  border-left: 3px solid var(--cfn-success);
  color: var(--cfn-success-text);
  font-size: 0.875rem;
}

.drag-panel-distance {
  padding: 1rem;
  transition: all 0.3s ease;
}

.drag-panel-distance.status-safe {
  background: var(--cfn-success-muted);
}

.drag-panel-distance.status-warning {
  background: var(--cfn-warning-muted);
}

.drag-panel-distance.status-danger {
  background: var(--cfn-danger-muted);
}

.drag-panel-distance.status-exceeded {
  background: var(--cfn-danger-muted);
}

.drag-panel-instructions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--cfn-info-muted);
  border-left: 3px solid var(--cfn-info);
  color: var(--cfn-info-text);
  font-size: 0.875rem;
}

.dragging-indicator {
  margin-left: auto;
  font-weight: 600;
  color: var(--cfn-accent-primary);
}

.drag-panel-actions {
  display: flex;
  gap: 0.5rem;
  padding: 1rem;
  border-top: 1px solid var(--cfn-border);
}

.drag-panel-actions button {
  flex: 1;
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .structure-move-drag-panel {
    width: calc(100vw - 2rem);
    top: auto;
    bottom: 1rem;
  }
  .structure-move-dialog .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .structure-move-dialog .grid-cols-2 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .mode-btn {
    padding: 0.5rem 0.25rem;
    font-size: 0.75rem;
  }

  .distance-value {
    font-size: 1rem;
  }

  .position-summary .grid-cols-2 {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/home/components/structure-move-dialog.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;;;;;EAKE;AACF;EACE,+BAA+B;AACjC;;AAEA;EACE,uGAAuG;EACvG,oBAAoB;EACpB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,qCAAqC;AACrC;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,mCAAmC;EACnC,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qBAAqB;EACrB,kCAAkC;EAClC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,mGAAmG;EACnG,4BAA4B;EAC5B,+BAA+B;EAC/B,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,iDAAiD;EACjD,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA,+DAA+D;AAC/D;EACE,mCAAmC;AACrC;AAFA;EACE,mCAAmC;AACrC;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,uCAAuC;EACvC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;EAChD,2CAA2C;AAC7C;;AAEA,oEAAoE;AACpE;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mCAAmC;EACnC,qBAAqB;EACrB,gCAAgC;EAChC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mCAAmC;EACnC,wCAAwC;EACxC,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,yCAAyC;EACzC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iCAAiC;EACjC,sCAAsC;EACtC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,OAAO;AACT;;AAEA,2BAA2B;AAC3B;EACE;IACE,yBAAyB;IACzB,SAAS;IACT,YAAY;EACd;EACA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Structure Move Dialog Styles\n *\n * Uses CFN theme variables for light/dark theme support.\n * See /app/public/css/cfn-theme.css for variable definitions.\n */\n\n/*\n * CRITICAL FIX: Allow map interaction through the dialog overlay\n * The dialog overlay blocks all pointer events to the map beneath.\n * We disable pointer events on the overlay so users can drag markers,\n * but re-enable them on the dialog content itself.\n */\n[data-radix-dialog-overlay] {\n  pointer-events: none !important;\n}\n\n.structure-move-dialog {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  pointer-events: auto;\n  color: var(--cfn-text-primary);\n  background: var(--cfn-bg-secondary);\n}\n\n/* Ensure alerts have good contrast */\n.structure-move-dialog [role=\"alert\"] {\n  color: var(--cfn-text-primary);\n}\n\n.structure-move-content {\n  padding: 1rem 0;\n}\n\n/* Mode selector */\n.mode-selector {\n  margin-bottom: 1rem;\n}\n\n.mode-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem 0.5rem;\n  border: 1px solid var(--cfn-border);\n  border-radius: 0.375rem;\n  background: var(--cfn-bg-tertiary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--cfn-text-secondary);\n}\n\n.mode-btn:hover {\n  background: var(--cfn-bg-elevated);\n  border-color: var(--cfn-accent-primary);\n  color: var(--cfn-accent-primary);\n}\n\n.mode-btn.active {\n  background: var(--cfn-accent-primary-muted);\n  border-color: var(--cfn-accent-primary);\n  color: var(--cfn-accent-primary);\n  font-weight: 600;\n}\n\n.mode-btn i,\n.mode-btn svg {\n  margin-bottom: 0.25rem;\n}\n\n/* Distance indicator */\n.distance-indicator {\n  padding: 1rem;\n  border-radius: 0.5rem;\n  background: var(--cfn-bg-tertiary);\n  border: 1px solid var(--cfn-border);\n  transition: all 0.3s ease;\n}\n\n.distance-indicator.status-safe {\n  background: var(--cfn-success-muted);\n  border-color: var(--cfn-success);\n}\n\n.distance-indicator.status-warning {\n  background: var(--cfn-warning-muted);\n  border-color: var(--cfn-warning);\n}\n\n.distance-indicator.status-danger {\n  background: var(--cfn-danger-muted);\n  border-color: var(--cfn-danger);\n}\n\n.distance-indicator.status-exceeded {\n  background: var(--cfn-danger-muted);\n  border-color: var(--cfn-danger);\n}\n\n.distance-bar {\n  width: 100%;\n  height: 8px;\n  background: var(--cfn-bg-elevated);\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n}\n\n.distance-fill {\n  height: 100%;\n  transition: all 0.3s ease;\n  border-radius: 4px;\n}\n\n.status-safe .distance-fill {\n  background: linear-gradient(90deg, var(--cfn-success), var(--cfn-success-text));\n}\n\n.status-warning .distance-fill {\n  background: linear-gradient(90deg, var(--cfn-warning), var(--cfn-warning-text));\n}\n\n.status-danger .distance-fill {\n  background: linear-gradient(90deg, var(--cfn-danger), var(--cfn-danger-text));\n}\n\n.status-exceeded .distance-fill {\n  background: linear-gradient(90deg, var(--cfn-danger), #991b1b);\n}\n\n.distance-text {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n\n.distance-value {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: var(--cfn-text-primary);\n}\n\n.status-safe .distance-value {\n  color: var(--cfn-success-text);\n}\n\n.status-warning .distance-value {\n  color: var(--cfn-warning-text);\n}\n\n.status-danger .distance-value {\n  color: var(--cfn-danger-text);\n}\n\n.status-exceeded .distance-value {\n  color: var(--cfn-danger-text);\n}\n\n.distance-max {\n  font-size: 0.875rem;\n  color: var(--cfn-text-muted);\n}\n\n/* Position summary */\n.position-summary {\n  padding: 0.75rem;\n  background: var(--cfn-bg-tertiary);\n  border-radius: 0.375rem;\n  border: 1px solid var(--cfn-border);\n}\n\n/* Input fields */\n.mode-inputs input[type=\"number\"] {\n  font-family: ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;\n  color: var(--cfn-input-text);\n  background: var(--cfn-input-bg);\n  border: 1px solid var(--cfn-input-border);\n  border-radius: 0.375rem;\n}\n\n.mode-inputs input[type=\"number\"]:focus {\n  border-color: var(--cfn-input-focus-border);\n  box-shadow: 0 0 0 3px var(--cfn-input-focus-ring);\n  outline: none;\n}\n\n.mode-inputs input[type=\"number\"]:disabled {\n  color: var(--cfn-text-disabled);\n  background: var(--cfn-bg-tertiary);\n}\n\n/* Ensure all input placeholders are visible but not too dark */\n.mode-inputs input::placeholder {\n  color: var(--cfn-input-placeholder);\n}\n\n/* Leaflet marker styles */\n.structure-move-ghost-marker {\n  opacity: 0.4;\n  z-index: 9000 !important;\n}\n\n.ghost-marker-inner {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--cfn-text-muted);\n  border: 2px solid var(--cfn-bg-primary);\n  box-shadow: var(--cfn-shadow-md);\n}\n\n.structure-move-preview-marker {\n  opacity: 1;\n  cursor: move;\n  z-index: 10000 !important;\n}\n\n.preview-marker-inner {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: var(--cfn-accent-primary);\n  border: 3px solid var(--cfn-bg-primary);\n  box-shadow: 0 4px 12px var(--cfn-focus-ring);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--cfn-btn-primary-text);\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.structure-move-preview-marker:hover .preview-marker-inner {\n  transform: scale(1.1);\n  box-shadow: 0 6px 16px var(--cfn-focus-border);\n}\n\n.structure-move-preview-marker.leaflet-drag-target .preview-marker-inner {\n  transform: scale(1.2);\n  box-shadow: 0 8px 20px var(--cfn-accent-primary);\n  background: var(--cfn-accent-primary-hover);\n}\n\n/* Floating drag panel - shown instead of full dialog in drag mode */\n.structure-move-drag-panel {\n  position: fixed;\n  top: 1rem;\n  right: 1rem;\n  width: 320px;\n  background: var(--cfn-bg-secondary);\n  border: 1px solid var(--cfn-border);\n  border-radius: 0.5rem;\n  box-shadow: var(--cfn-shadow-xl);\n  z-index: 10000;\n  pointer-events: auto;\n}\n\n.drag-panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid var(--cfn-border);\n}\n\n.drag-panel-title {\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  color: var(--cfn-text-primary);\n}\n\n.drag-panel-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: var(--cfn-text-muted);\n  padding: 0;\n  width: 2rem;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.25rem;\n  transition: all 0.2s;\n}\n\n.drag-panel-close:hover {\n  background: var(--cfn-bg-tertiary);\n  color: var(--cfn-text-primary);\n}\n\n.drag-panel-error {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: var(--cfn-danger-muted);\n  border-left: 3px solid var(--cfn-danger);\n  color: var(--cfn-danger-text);\n  font-size: 0.875rem;\n}\n\n.drag-panel-success {\n  padding: 0.75rem 1rem;\n  background: var(--cfn-success-muted);\n  border-left: 3px solid var(--cfn-success);\n  color: var(--cfn-success-text);\n  font-size: 0.875rem;\n}\n\n.drag-panel-distance {\n  padding: 1rem;\n  transition: all 0.3s ease;\n}\n\n.drag-panel-distance.status-safe {\n  background: var(--cfn-success-muted);\n}\n\n.drag-panel-distance.status-warning {\n  background: var(--cfn-warning-muted);\n}\n\n.drag-panel-distance.status-danger {\n  background: var(--cfn-danger-muted);\n}\n\n.drag-panel-distance.status-exceeded {\n  background: var(--cfn-danger-muted);\n}\n\n.drag-panel-instructions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: var(--cfn-info-muted);\n  border-left: 3px solid var(--cfn-info);\n  color: var(--cfn-info-text);\n  font-size: 0.875rem;\n}\n\n.dragging-indicator {\n  margin-left: auto;\n  font-weight: 600;\n  color: var(--cfn-accent-primary);\n}\n\n.drag-panel-actions {\n  display: flex;\n  gap: 0.5rem;\n  padding: 1rem;\n  border-top: 1px solid var(--cfn-border);\n}\n\n.drag-panel-actions button {\n  flex: 1;\n}\n\n/* Responsive adjustments */\n@media (max-width: 640px) {\n  .structure-move-drag-panel {\n    width: calc(100vw - 2rem);\n    top: auto;\n    bottom: 1rem;\n  }\n  .structure-move-dialog .grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .structure-move-dialog .grid-cols-2 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .mode-btn {\n    padding: 0.5rem 0.25rem;\n    font-size: 0.75rem;\n  }\n\n  .distance-value {\n    font-size: 1rem;\n  }\n\n  .position-summary .grid-cols-2 {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
